import { useMutation, UseMutationResult } from '@taxdown/zeno-sama-query';
import UserService from 'Services/user';
import { QueryKeys, ResponseType } from 'Types/common';

export const useFetchSaveUserphone = (): UseMutationResult<ResponseType<unknown>, string> =>
  useMutation([QueryKeys.SAVE_DASHBOARD_PHONE], UserService.setUserPhone);
